<template>
    <div class="Controls">
        {{value}}
    </div>
</template>

<script>
export default {
  name: 'Controls',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  },
  watch: {
  },
  components: {
  }
}
</script>
